<template>
  <div class="container">
      <div class="body_top" v-if="notice">
            <div class="body_top_left">
                     <img v-if="notice.noticeLabel=='园区公告'" class="body_top_left_icon" src="../../assets/images/icon_notice_park.png">
                     <img v-else-if="notice.noticeLabel=='新闻动态'" class="body_top_left_icon" src="../../assets/images/icon_notice_news.png"/>
                     <img v-else class="body_top_left_icon" src="../../assets/images/icon_notice_weather.png"/>
                     <span class="body_top_left_span">{{notice.noticeLabel}}</span>
            </div>
            <span v-if="notice.updateTime" class="body_top_right">{{notice.updateTime | formatTime}}</span>
            <span v-else class="body_top_right">{{notice.createTime | formatTime}}</span>
     </div>
     <div class="body_top_title_div">
        <span class="body_top_title_span">{{notice.noticeTitle}}</span>
     </div>
     <div class="body_body" v-if="html">
         <div class="body_body_detail">
             <div class="body_body_detail_span" v-html="html"></div>
         </div>

         <div class="body_body_buttons">
             <span class="body_body_buttons_left">阅读 {{notice.browseCount}}</span>
             <div class="body_body_buttons_right">
                 <span @click="savePraiseAction()" :class="['body_body_buttons_right_span',notice.isPraise?'body_body_buttons_right_span_c':'']">{{notice.praiseCount}}</span>
                 <img @click="savePraiseAction()" v-if="notice.isPraise" class="body_body_buttons_right_icon" :src="require(`../../assets/images/icon_praise_h_${common.theme}.png`)"/>
                 <img @click="savePraiseAction()" v-else class="body_body_buttons_right_icon" src="../../assets/images/icon_praise_n.png"/>
             </div>
         </div>
     </div>

     <div class="body_liuyan_top" v-if="list.length>0">
         <span class="body_liuyan_top_left">精选留言</span>
         <!-- 是否评论（commentType 0：不评论，1：评论） -->
         <span class="body_liuyan_top_right" v-if="notice.commentType == 1" @click="toliuYan()">写留言</span>
     </div>

      <div class="body_liuyan_nodata_top" v-if="list.length == 0 && notice.commentType == 1">
         <span class="body_liuyan_nodata_left">还没有留言哦~</span>
         <span class="body_liuyan_nodata_right" @click="toliuYan()">写留言</span>
     </div>

     <div class="liuyan_list">
         <div class="liuyan_list_cell" v-for="(item,index) in list" :key="index">
            <div class="liuyan_list_item">

                    <img class="liuyan_list_item_img" v-if="item.photoPath" :src="item.photoPath"/>
                    <img class="liuyan_list_item_img" v-else :src="require(`../../assets/images/img_default_face_${common.theme}.jpg`)"/>
                    <div class="liuyan_list_item_right">
                         <span class="liuyan_list_item_right_span1">{{item.userName}}</span>
                         <span class="liuyan_list_item_right_span2">{{item.commentContent}}</span>
                          <div  v-if="item.returnContent" class="author">
                            <div class="authorLine"></div>
                            <span class="liuyan_list_item_right_span1">作者</span>
                         </div>
                         <span v-if="item.returnContent" class="liuyan_list_item_right_span2">{{item.returnContent}}</span>
                    </div>
            </div>
         </div>
     </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getNoticeDetailById ,getCommentList,savePraise } from "../../utils/api";
import util from '../../utils/util';
export default {
  name: "noticeList",
//   components: {
//      Scroll,
//   },

  data() {
    return {
      noticeID:'',
      list:[],
      saveStatus:true,
      notice:'',
      html:'',
    }
  },
  computed: {
    ...mapState({
      common: state => state.common,
    })
  },

  filters: {

    formatTime(val){
      return util.formatTime(new Date(val),4)
      //configObj.formatTime(new Date(val),'-','yyyymmdd');
    }
  },


  created() {
    //this.getNoticeListAction();
  },
  activated () {
    //this.getParkInfo();
    if (this.noticeID !== this.$route.params.id) {
      this.noticeID = this.$route.params.id;
      this.getNoticeDetailAction();
    }
    this.getCommentListAction();
  },

  methods: {

      getNoticeDetailAction(){
          console.log("in getNoticeDetailAction");
          let params = {
         // 'accessToken': "420A85C6F8EE4A398DF88BFDCC1A2701", //'57d52877043b9e819fda0736e46232f8',
          marketId:  this.common.marketInfo.id,
          userId:this.common.userId,
          'noticeId': this.noticeID
      }

       getNoticeDetailById(params).then(res => {
          this.isLoding=false;
        // this.isFrist =false;
        if (res.res.code === 10000 && res.body) {
            console.log(res)
            this.notice = res.body;
            this.html = res.body.noticeDetails;
        }
        });

      },

       getCommentListAction() {
           console.log("in getCommentListAction");
           let params = {
             "userId": this.common.userId,
            "commentType": "1",
            "bussinessId": this.noticeID,
            "pageNo": 1,
             "pageSize": 100
           }
         getCommentList(params).then(res => {
          console.log(res);
          if (res.res.code === 10000) {
            this.list = res.body.userCommentOutputList
          }
        });
      },
      savePraiseAction(){
         if(!this.saveStatus){
          return false;
        }
        this.saveStatus = false;
          var status = '';
          if(this.notice.isPraise){
            status = '1'
          }else{
            status = '0'
          }
          console.log(status)
          let params = {
            "userId": this.common.userId,
            "praiseType": "1",
            "bussinessId": this.noticeID,
            "isDrop": status
          }
          savePraise(params).then(res => {
            this.saveStatus = true;
            //console.log(res);
            if (res.res.code === 10000) {
               if (Number(status)) {
                    this.notice.isPraise = false
                    this.notice.praiseCount = Number(this.notice.praiseCount) - 1
               } else {
                    this.notice.isPraise = true
                    this.notice.praiseCount = Number(this.notice.praiseCount) + 1
               }
            }else{
                if(res.res.msg== "不能重复点赞"){
                    this.notice.isPraise = true
                }
            }
        });

      },


        // 公告留言
    toliuYan() {
    //   this.$router.push(`/noticeFrom/${id}`);
    var time  =util.formatTime(new Date(this.notice.createTime),4)
    if (!this.$store.state.common.userId) {
        this.$router.replace({
          path: '/login',
          query: {
            Rurl: this.$route.fullPath
          }
        })
      } else {
        this.$router.push({
          path: `/noticeFrom?noticeID=${this.noticeID}&noticeLabel=${this.notice.noticeLabel}&noticeTime=${time}`
        })
      }
    // this.$router.push({
    //      path:
    // });
    }
  }
}

</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container {
  height: 100vh;
  background-color: #F3F4F6;
}

.body_top{
  width: 100%;
  height: 88px;
  border-radius:8px 8px 0px 0px;
  background-color:#FAFAFA;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #eaeaea;

}

.body_top_left{
  flex-direction: row;
  display: flex;
  margin-left: 28px;
}
.body_top_left_icon{
  width: 44px;
  display: flex;
  height: 44px;
}
.body_top_left_span{
  margin-left: 20px;
  height:40px;
  font-size:28px;
  font-weight:500;
  color:rgba(51,51,51,1);
  line-height:40px;
}

.body_top_right{
  margin-right: 28px;
  height:34px;
  font-size:24px;
  font-weight:400;
  color:rgba(153,153,153,1);
  line-height:34px;

}

.body_top_title_div{
   width: 100%;
   background-color: white;
   height: 88px;
   flex-direction: column;
    display: flex;
   .body_top_title_span{
      margin-left: 28px;
      margin-top: 28px;
      width:694px;
      height:60px;
      font-size:44px;
      font-weight:500;
      color:rgba(51,51,51,1);
      line-height:60px;
   }
}

.body_body{
    width: 100%;
    // min-height: 400px;
    flex-direction: column;
    display: flex;
    background-color: white;
}

.body_body_detail{
    margin-left: 28px;
    margin-top: 28px;
    flex-direction: column;
    display: flex;
    background-color: white;
    width: 694px;
    min-height: 284px;
}
.body_body_detail_span{
    // font-size:28px;
    // font-weight:400;
    // color:rgba(51,51,51,1);
    // line-height:40px;
    padding-top: 10px;
    /deep/ strong {
        font-weight: bold;
        .fontSize(15px);
        line-height: 50px;
    }
    /deep/ p,
    /deep/ span {
        .fontSize(14px);
        color: rgba(0, 0, 0, 0.9);
        line-height: 40px;
    }
    /deep/ img {
        max-width: 100%;
        min-width: 40%;
        margin: 10px auto;
        height: auto;
        display: block;
    }
    /deep/ figcaption {
        text-align: center;
        .fontSize(14px);
        line-height: 50px;
    }
    /deep/ tr,
    td,
    th {
        .fontSize(14px);
    }

}

.body_body_buttons{
    width: 100%;
    height: 88px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    // align-items: center;

}
.body_body_buttons_left{
    margin-left: 28px;
    margin-top: 28px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(153,153,153,1);
    line-height:40px;
}

.body_body_buttons_right{
    margin-right: 28px;
     margin-top: 28px;
    height: 40px;
    flex-direction: row;
     display: flex;
    // justify-content: space-between;
    // align-items: center;
}
.body_body_buttons_right_span{
    height:28px;
    font-size:24px;
    font-weight:400;
    color:rgba(201,201,201,1);
    line-height:28px;
    margin-top: 8px;

}
.body_body_buttons_right_span_c{
  color:@color17;
}
.body_body_buttons_right_icon{
    margin-left: 8px;
    margin-top: 2px;
    width: 30px;
    height: 28px;

}

.body_liuyan_top{
     width: 100%;
     height: 88px;
     display: flex;
     flex-direction: row;
     justify-content: space-between;
     align-items: center;

}

.body_liuyan_top_left{
    margin-left: 28px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:40px;
}

.body_liuyan_top_right{
    margin-right: 28px;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(23,64,218,1);
    line-height:40px;
}

.body_liuyan_nodata_top{
     width: 100%;
     display: flex;
     flex-direction: column;
     background-color: #F3F4F6;
     padding-bottom: 40px;

}
.body_liuyan_nodata_left{
     width: 100%;
     margin-top: 60px;
     text-align: center;
    height:40px;
    font-size:28px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:40px;

}
.body_liuyan_nodata_right{
    width: 100%;
    text-align: center;
    margin-top: 60px;
    height:40px;
    font-size:28px;
    color:rgba(23,64,218,1);
    line-height:40px;
}


.liuyan_list{
    width: 100%;
    background-color: #F3F4F6;
    flex-direction: column;
}

.liuyan_list_cell{
  width: 100%;
  display: flex;
  // min-height: 204px;
  margin-bottom:40px;
  flex-direction: column;
  background-color: #F3F4F6;
//   border: 2px solid #eaeaea;
}
.liuyan_list_item{
  margin-left: 28px;
  margin-top: 10px;
  padding-bottom: 10px;
  width: 694px;
  display: flex;
  flex-direction: row;
//   background-color:rgba(255,255,255,1);

}

.liuyan_list_item_img{
    width:80px;
    height:80px;
    border: 2px solid #eaeaea;
    border-radius: 40px;
}
.liuyan_list_item_right{
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    width:598px;
}

.liuyan_list_item_right_span1{
    width:598px;
    height:32px;
    font-size:28px;
    font-family:PingFangSC;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:32px;

}
.liuyan_list_item_right_span2{
    margin-top: 10px;
    width:598px;
    font-size:28px;
    font-family:PingFangSC;
    font-weight:400;
    color:rgba(51,51,51,1);
    line-height:40px;
}
.author{
   margin-top: 10px;
   width:598px;
   height:32px;
   display: flex;
   flex-direction: row;
}
.authorLine{
  margin-top: 4px;
  width: 5px;
  height: 24px;
  background-color: #0087ff;
  display: flex;
  margin-right: 8px;
  border-radius: 2px;
}

</style>